import { defineMessages } from 'react-intl';

export default defineMessages({
  comment: {
    id: 'sentinel.components.suspendTransferForm.comment',
    defaultMessage: 'Comment (optional)',
  },
  suspendWire: {
    id: 'sentinel.components.suspendTransferForm.suspendTransfer',
    defaultMessage: 'Suspend Wire',
  },
});



// WEBPACK FOOTER //
// ./src/components/SuspendWireTransferForm/messages.js